module.exports = __webpack_public_path__ + "img/VITO.1543025e.jpg";